<!--
 * @Descripttion: 
 * @version: v1
 * @Author: liukx
 * @Date: 2022-05-01 23:09:12
 * @LastEditors: ???
 * @LastEditTime: 2022-06-08 15:18:13
-->
<template>
  <div class="wrapper">
    <el-dialog
      :close-on-click-modal="false"
      :title="title"
      :visible.sync="visible"
      width="50%"
      @close="close"
    >
      <div class="proceeds">
        <span style="font-size: 16px">合同信息</span>
      </div>
      <div style="height: 20px"></div>
      <el-form
        :model="form"
        ref="form"
        :rules="validatorRules"
        label-width="120px"
        :inline="false"
        size="normal"
        :disabled="formDisabled"
      >
        <el-form-item label="合同编号：" style="width: 500px" prop="contractNo">
          <el-input
            :disabled="form.contractState == 2"
            v-model.trim="form.contractNo"
            placeholder="请输入合同编号"
            maxlength="50"
            style="width: 90%"
          ></el-input>
        </el-form-item>
        <el-form-item
          label="合同名称："
          style="width: 500px"
          prop="contractName"
        >
          <el-input
            :disabled="form.contractState == 2"
            v-model.trim="form.contractName"
            placeholder="请输入合同名称"
            maxlength="30"
            style="width: 90%"
          ></el-input>
        </el-form-item>
        <el-form-item
          label="对方公司："
          style="width: 500px"
          prop="otherCompany"
        >
          <el-input
            :disabled="form.contractState == 2"
            v-model.trim="form.otherCompany"
            placeholder="请输入对方公司名称"
            maxlength="30"
            style="width: 90%"
          ></el-input>
        </el-form-item>
        <el-form-item
          label="合同金额："
          style="width: 500px"
          prop="contractAmount"
        >
          <el-input
            :disabled="form.contractState == 2"
            v-model.trim="form.contractAmount"
            placeholder="请输入合同金额"
             
            style="width: 90%"
          ></el-input>
        </el-form-item>
        <el-form-item
          label="结算价："
          style="width: 500px"
          prop="settlementPrice"
        >
          <el-input
            :disabled="form.contractState == 2"
            v-model.trim="form.settlementPrice"
            placeholder="请输入结算价"
             
            style="width: 90%"
          ></el-input>
        </el-form-item>
        <el-form-item label="签订日期：" style="width: 500px">
          <el-col :span="11">
            <el-form-item prop="signDate">
              <el-date-picker
                :disabled="form.contractState == 2"
                type="date"
                placeholder="选择日期"
                v-model="form.signDate"
                style="width: 100%"
              ></el-date-picker>
            </el-form-item>
          </el-col>
        </el-form-item>
        <el-form-item label="起始日期：" style="width: 500px">
          <el-col :span="11">
            <el-form-item prop="startDate">
              <el-date-picker
                :disabled="form.contractState == 2"
                type="date"
                placeholder="选择日期"
                v-model="form.startDate"
                style="width: 100%"
              ></el-date-picker>
            </el-form-item>
          </el-col>
        </el-form-item>
        <el-form-item label="截止日期：" style="width: 500px">
          <el-col :span="11">
            <el-form-item prop="endDate">
              <el-date-picker
                :disabled="form.contractState == 2"
                type="date"
                placeholder="选择日期"
                v-model="form.endDate"
                style="width: 100%"
              ></el-date-picker>
            </el-form-item>
          </el-col>
        </el-form-item>
        <el-form-item
          label="已收账款："
          style="width: 500px"
          prop="receiptedAmount"
        >
          <el-input
            :disabled="form.contractState == 2"
            v-model.trim="receiptedAmount"
            placeholder="请输入已收账款"
             
            style="width: 90%"
          ></el-input>
        </el-form-item>
        <el-form-item
          label="已结束合同扣款金额："
          style="width: 500px"
          prop="deductionAmount"
        >
          <el-input
            :disabled="form.contractState == 2"
            v-model.trim="form.deductionAmount"
            placeholder="请输入已结束合同扣款金额"
             
            style="width: 90%"
          ></el-input>
        </el-form-item>
        <el-form-item
          label="应收账款余额："
          style="width: 500px"
          prop="receivableAmount"
        >
          <el-input
            :disabled="form.contractState == 2"
            v-model.trim="form.receivableAmount"
            placeholder="请输入应收账款余额"
             
            style="width: 90%"
          ></el-input>
        </el-form-item>
        <el-form-item
          label="实际贴印花税："
          style="width: 500px"
          prop="actualStampDuty"
        >
          <el-input
            :disabled="form.contractState == 2"
            v-model.trim="form.actualStampDuty"
            placeholder="请输入实际贴印花税"
             
            style="width: 90%"
          ></el-input>
        </el-form-item>
        <el-form-item
          label="印花税率："
          style="width: 500px"
          prop="stampDutyRate"
        >
          <el-input
            :disabled="form.contractState == 2"
            v-model.trim="form.stampDutyRate"
            placeholder="请输入印花税率"
             
            style="width: 90%"
          ></el-input>
        </el-form-item>
        <el-form-item
          label="应交印花税："
          style="width: 500px"
          prop="payableStampDuty"
        >
          <el-input
            :disabled="form.contractState == 2"
            v-model.trim="form.payableStampDuty"
            placeholder="请输入应交印花税"
             
            style="width: 90%"
          ></el-input>
        </el-form-item>
        <el-form-item label="交印花税时间：" style="width: 500px">
          <el-col :span="11">
            <el-form-item prop="payStampDutyTime">
              <el-date-picker
                :disabled="form.contractState == 2"
                type="date"
                placeholder="选择日期"
                v-model="form.payStampDutyTime"
                style="width: 100%"
              ></el-date-picker>
            </el-form-item>
          </el-col>
        </el-form-item>
        <el-form-item label="是否到期：" style="width: 500px" prop="isEnd">
          <el-radio-group
            :disabled="form.contractState == 2"
            v-model="form.isEnd"
          >
            <el-radio :label="0">否</el-radio>
            <el-radio :label="1">是</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item
          label="是否有合同："
          style="width: 500px"
          prop="haveContract"
        >
          <el-radio-group
            :disabled="form.contractState == 2"
            v-model="form.haveContract"
          >
            <el-radio :label="0">否</el-radio>
            <el-radio :label="1">是</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="备注：" style="width: 500px" prop="remark">
          <el-input
            :disabled="form.contractState == 2"
            v-model.trim="form.remark"
            placeholder="请输入价格(长度99字符内)"
            type="textarea"
            style="width: 90%"
          ></el-input>
        </el-form-item>

        <div class="proceeds">
          <span style="font-size: 16px">收款信息</span>
          <el-button
            type="primary"
            icon="el-icon-plus"
            plain
            circle
            size="mini"
            @click="addDomain"
            v-if="!formDisabled"
          ></el-button>
        </div>
        <div style="height: 20px"></div>
        <el-form-item
          style="width: 500px"
          v-for="(item, index) in form.detailList"
          :label="'收款' + (index + 1) + ':'"
          :key="item.key"
          :rules="{
            required: true,
            message: '收款不能为空',
            trigger: 'blur',
          }"
        >
          <el-input
            v-model.trim="item.receivedAmount"
            placeholder="请输入收款金额"
             
          ></el-input>
          <el-date-picker
          style="position: relative; top: 10px"
            type="date"
            placeholder="选择日期"
            v-model="item.receivedDate"
          ></el-date-picker>
          <el-button style="position: relative; top: 10px; left: 10px;" @click.prevent="removeDomain(item)" v-if="!formDisabled"
            >删除</el-button
          >
        </el-form-item>
      </el-form>

      <span slot="footer" v-if="!formDisabled">
        <el-button @click="visible = false" size="mini">取消</el-button>
        <el-button
          type="primary"
          @click="handleOk(1)"
          size="mini"
          v-if="form.contractState != 2"
          >存为草稿</el-button
        >
        <el-button type="primary" @click="handleOk(2)" size="mini"
          >确定提交</el-button
        >
      </span>
    </el-dialog>
  </div>
</template>

<script>
import { httpAction } from "@/api/manage";
// import { currency } from '@/utils/util';

import { listMixin } from "@/mixins/listMixin";
import { convertTime } from "@/utils/util";

var validateInput = (rule, value, callback) => {
  if (value === "") {
    callback(new Error("请输入名称"));
  }
  let newValue = value.replace(/[<>/\\]/g, "");
  if (newValue !== value) {
    callback(new Error("请勿输入特殊字符"));
  } else {
    callback();
  }
};
export default {
  components: {},
  mixins: [listMixin],
  props: {},
  data() {
    return {
      formDisabled: false,
      disableMixinCreated: true,
      title: "操作",
      visible: false,
      confirmLoading: false,
      form: {
        detailList: [],
      },
      validatorRules: {
        contractNo: [
          { required: true, message: "请输入合同编号", trigger: "blur" },
          { max: 50, message: "长度在 50 个字符以内", trigger: "change" },
          {
            validator: validateInput,
            message: "不可以输入特殊符号",
            trigger: "blur",
          },
        ],
        contractName: [
          { required: true, message: "请输入合同名称", trigger: "blur" },
          { max: 30, message: "长度在30个字符以内", trigger: "change" },
        ],
        otherCompany: [
          { required: true, message: "请输入对方公司名称", trigger: "blur" },
          { max: 30, message: "长度在30 个字符以内", trigger: "change" },
        ],
        // contractAmount: [
        //   { required: true, message: "请输入合同金额", trigger: "blur" },
        // ],
        // settlementPrice: [
        //   { required: true, message: "请输入结算价", trigger: "blur" },
        // ],
        // signDate: [
        //   { required: true, message: "请选择签订日期", trigger: "change" },
        // ],
        // startDate: [
        //   { required: true, message: "请选择起始日期", trigger: "change" },
        // ],
        // endDate: [
        //   { required: true, message: "请选择截止日期", trigger: "change" },
        // ],
        // receiptedAmount: [
        //   { required: true, message: "请输入已收账款", trigger: "blur" },
        // ],
        // deductionAmount: [
        //   {
        //     required: true,
        //     message: "请输入已结束合同扣款金额",
        //     trigger: "blur",
        //   },
        // ],
        // receivableAmount: [
        //   { required: true, message: "请输入应收账款余额", trigger: "blur" },
        // ],
        // isEnd: [
        //   { required: true, message: "请选择是否到期", trigger: "change" },
        // ],
        // haveContract: [
        //   { required: true, message: "请选择是否有合同", trigger: "change" },
        // ],
        // actualStampDuty: [
        //   { required: true, message: "请输入实际贴印花税", trigger: "blur" },
        // ],
        // stampDutyRate: [
        //   { required: true, message: "请输入印花税率", trigger: "blur" },
        // ],
        // payableStampDuty: [
        //   { required: true, message: "请输入应交印花税", trigger: "blur" },
        // ],
        // payStampDutyTime: [
        //   { required: true, message: "请输入交印花税时间", trigger: "blur" },
        // ],
        // remark: [
        //   { required: true, message: "请输入备注", trigger: "blur" },
        //   { max: 100, message: "长度在 100 个字符以内", trigger: "change" },
        //   {
        //     validator: validateInput,
        //     message: "不可以输入特殊符号",
        //     trigger: "blur",
        //   },
        // ],
      },
      url: {
        add: "/wlIncomeContract/addContract",
        edit: "/wlIncomeContract/updateContract",
        detail: "/wlIncomeContract/queryContract",
      },
    };
  },
  watch: {},
  computed: {
    receiptedAmount () {
      let num = 0
      this.form.detailList.forEach(
        (item) => (num += Number(item.receivedAmount))
      )
      return num
    }
  },
  methods: {
    removeDomain(item) {
      var index = this.form.detailList.indexOf(item);
      if (index !== -1) {
        this.form.detailList.splice(index, 1);
      }
    },
    addDomain() {
      this.form.detailList.push({
        receivedDate: "",
        receivedAmount: "",
        key: Date.now(),
      });
    },
    add() {
      this.edit();
    },
    edit(record, type) {
      this.formDisabled = type;
      record &&
        httpAction(this.url.detail + "?id=" + record.id, {}, "get").then(
          (res) => {
            if (res.code === 200) {
              this.form = res.data;
              this.$refs["form"].clearValidate("productImage");
            }
          }
        );
      this.visible = true;
    },
    close() {
      this.$refs.form.resetFields();
      this.form = {
        detailList: [],
      };
      this.$emit("close");
      this.visible = false;
    },
    handleOk(state) {
      if (this.form.signDate && typeof this.form.signDate !== "string")
        this.form.signDate = convertTime(this.form.signDate);
      if (this.form.startDate && typeof this.form.startDate !== "string")
        this.form.startDate = convertTime(this.form.startDate);
      if (this.form.endDate && typeof this.form.endDate !== "string")
        this.form.endDate = convertTime(this.form.endDate);
      if (
        this.form.payStampDutyTime &&
        typeof this.form.payStampDutyTime !== "string"
      )
        this.form.payStampDutyTime = convertTime(this.form.payStampDutyTime);
      if (this.form.detailList.length) {
        for (let i = 0; i < this.form.detailList.length; i++) {
          const item = this.form.detailList[i];
          if (!item.receivedAmount || !item.receivedDate)
            return this.$message.warning("请填写完整收款内容");
          if (item.receivedDate && typeof item.receivedDate !== "string")
            item.receivedDate = convertTime(item.receivedDate);
        }
      }
      const that = this;
      // 触发表单验证
      this.$refs.form.validate((valid) => {
        if (valid) {
          this.$refs["form"].clearValidate("productImage");
          that.confirmLoading = true;
          let httpurl = "";
          let method = "";
          const parms = { ...this.form };
          parms.contractState = state;
          if (!this.form.id) {
            httpurl += this.url.add;
            method = "post";
          } else {
            httpurl += this.url.edit;
            method = "post"; //put
            parms.id = this.form.id;
          }
          httpAction(httpurl, parms, method)
            .then((res) => {
              if (res.code == 200) {
                that.$message.success("操作成功");
                that.$emit("ok");
              } else {
                that.$message.warning(res.msg);
              }
            })
            .finally(() => {
              that.confirmLoading = false;
              that.close();
            });
        }
      });
    },
  },
  created() {},
  mounted() {},
};
</script>
<style lang="less" scoped>
.wrapper {
}
.hide /deep/ .el-upload--picture-card {
  display: none;
}
.show /deep/ .el-upload--picture-card {
  display: block;
}
.proceeds {
  border-bottom: 1px solid #ccc;
  padding: 20px 0;
  span {
    color: black;
    font-weight: bold;
    margin-left: 30px;
    margin-right: 10px;
  }
}
</style>
